import { firebaseDb } from "../../firebase";

export const GET_TEMPLATES_LIST_REQUEST = "GET_TEMPLATES_LIST_REQUEST";
export const GET_TEMPLATES_LIST_SUCCESS = "GET_TEMPLATES_LIST_SUCCESS";
export const GET_TEMPLATES_LIST_FAILURE = "GET_TEMPLATES_LIST_FAILURE";

export const getTemplatest = (userId, isFirst = false) => dispatch => {
  try {
    !isFirst && dispatch({ type: GET_TEMPLATES_LIST_REQUEST });
    firebaseDb
      .ref(`/user-report-templates/${userId}`)
      .once("value", snapshot => {
        dispatch({ type: GET_TEMPLATES_LIST_SUCCESS, payload: snapshot.val() });
      });
  } catch (e) {
    !isFirst && dispatch({ type: GET_TEMPLATES_LIST_FAILURE });
  }
};

export const addTemplate = (userId, template) => async dispatch => {
  let data = { ...template };
  let updates = {};
  const list = await firebaseDb
    .ref(`/user-report-templates/${userId}/list`)
    .push();
  data.id = list.key;
  updates[`/user-report-templates/${userId}/list/${data.id}`] = data;

  await firebaseDb.ref().update(updates);
};

export const editTemplate = (userId, template) => async dispatch => {
  let data = { ...template };
  let updates = {};
  updates[`/user-report-templates/${userId}/list/${data.id}`] = data;

  await firebaseDb.ref().update(updates);
};

export const editTemplateType = (
  userId,
  templateId,
  type
) => async dispatch => {
  let updates = {};
  updates[
    `/user-report-templates/${userId}/list/${templateId}/typeReport`
  ] = type;

  await firebaseDb.ref().update(updates);
};

export const deleteTemplate = (userId, templateId) => async dispatch => {
  await firebaseDb
    .ref(`/user-report-templates/${userId}/list/${templateId}`)
    .remove();
};

export const copyTemplate = (userId, template) => async dispatch => {
  let updates = {};
  const data = { ...template };
  const list = await firebaseDb
    .ref(`/user-report-templates/${userId}/list`)
    .push();
  data.id = list.key;
  data.title = "copy_" + data.title;
  console.log(data.id, "data.id");
  updates[`/user-report-templates/${userId}/list/${data.id}`] = data;

  await firebaseDb.ref().update(updates);
};

export const uploadImage = (image, filename) => () => {
  return fetch(
    `https://www.filestackapi.com/api/store/S3?key=AYAOuFRuST2Z03icMtJLCz&filename=${filename}`,
    {
      method: "post",
      body: image
    }
  ).then(resp => resp.json());
};

export const deleteImage = id => () => {
  return fetch(
    `https://www.filestackapi.com/api/file/${id}?key=AYAOuFRuST2Z03icMtJLCz`,
    {
      method: "delete"
    }
  ).then(resp => resp.json());
};

export const changeReportFields = (userId, templateId, fields) => async dispatch => {
    let updates = {};
    Object.keys(fields).forEach((key) => {
        updates[`/user-report-templates/${userId}/list/${templateId}/reportFields/${key}`] = fields[key];
    })

    await firebaseDb.ref().update(updates);
};
